import React from 'react';

const SocialProof = () => {
  return (
    <section className="py-24 lg:py-36 bg-[#0A0A0B]" data-testid="social-proof-section">
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center">
          <p className="label-sm text-[#14B8A6] mb-10" data-font="label">What happens when it works</p>

          <blockquote className="mb-8">
            <p className="text-2xl sm:text-3xl lg:text-4xl font-light text-[#F0EDE8] leading-snug italic" data-testid="social-proof-quote">
              "What book is this from? I need to read it immediately."
            </p>
          </blockquote>

          <p className="text-[#E8E4DF]" data-testid="social-proof-context">
            Comments on Whisky Woven videos. Every time. Books that don't even exist yet.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
